"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as l } from "react";
import h from "../components/Icon/SvgIcon.js";
const m = (o) => /* @__PURE__ */ a(
  h,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.853 7.316a.46.46 0 0 0-.353-.146h-2.178L19.324 5a.46.46 0 0 0-.147-.353.45.45 0 0 0-.345-.147h-.996a.46.46 0 0 0-.353.147.46.46 0 0 0-.13.337l-.005 2.184-2.141-.002a.46.46 0 0 0-.377.162.45.45 0 0 0-.146.346l-.002.987a.45.45 0 0 0 .152.369c.09.098.22.151.354.146l2.162-.001.002 2.167a.46.46 0 0 0 .144.348.46.46 0 0 0 .348.144h1.027c.13.002.256-.05.345-.147a.46.46 0 0 0 .146-.353l.008-2.159 2.13-.014a.46.46 0 0 0 .352-.147.46.46 0 0 0 .148-.353v-1a.45.45 0 0 0-.147-.345m-8.022 2.041H7.759a.3.3 0 0 1-.213-.09.3.3 0 0 1-.09-.213V7.238q0-.124.09-.214a.3.3 0 0 1 .213-.09h6.107c-.131.23-.205.492-.2.762l-.002.949c-.006.255.058.496.167.712m4.047 3.493h.994c.248 0 .484-.067.696-.179V13.9q0 .123-.09.212a.3.3 0 0 1-.213.09H7.759a.3.3 0 0 1-.213-.09.3.3 0 0 1-.09-.213v-1.816q0-.123.09-.213a.3.3 0 0 1 .213-.09h8.647a1.484 1.484 0 0 0 1.425 1.071h.047m1.387 3.774H7.759a.3.3 0 0 0-.213.09.3.3 0 0 0-.09.213v1.816q0 .124.09.213.09.09.213.09h11.506a.3.3 0 0 0 .213-.09q.09-.09.09-.213v-1.816a.3.3 0 0 0-.09-.213.3.3 0 0 0-.213-.09M3.697 9.864a1.697 1.697 0 1 0 0-3.394 1.697 1.697 0 0 0 0 3.394m1.698 3.126a1.697 1.697 0 1 1-3.395 0 1.697 1.697 0 0 1 3.395 0m-1.698 6.643a1.697 1.697 0 1 0 0-3.394 1.697 1.697 0 0 0 0 3.394",
        clipRule: "evenodd"
      }
    )
  }
), n = l(m);
export {
  n as ShoppingList,
  n as default
};
